import React from "react";
import { Droplets, Smartphone, PlaneLanding, Package } from "lucide-react";
import { Eyebrow } from "@/components/site/Bits";
import { InquiryForm } from "@/components/site/InquiryForm";

const PERKS = [
  { icon: Droplets, t: "Complimentary bottled water", d: "Provided for the full duration of qualifying 5+ night stays." },
  { icon: Smartphone, t: "Registered SIM card", d: "Complimentary local SIM with mobile-money capability, set up on arrival." },
  { icon: PlaneLanding, t: "Airport pickup & drop-off", d: "Complimentary transfers to and from Accra International Airport." },
];

export const Waitlist2027 = () => (
  <section className="relative overflow-hidden bg-navy py-20 text-white grain" data-testid="waitlist-2027">
    <div className="container-x relative grid gap-12 lg:grid-cols-[1fr_460px]">
      <div>
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-mint">Accra 5+ night package · Coming 2027</p>
        <h2 className="mt-4 max-w-xl text-3xl tracking-tight sm:text-4xl lg:text-5xl">Stay 5+ nights. Travel with more included.</h2>
        <p className="mt-4 max-w-xl text-sm text-white/65 md:text-base">For qualifying future Accra stays of five nights or more. These perks are not available yet — join the waitlist and we will contact you first when they launch.</p>
        <div className="mt-10 grid gap-4 sm:grid-cols-3">
          {PERKS.map((p, i) => (
            <div key={p.t} className="rounded-2xl border border-white/10 bg-white/[0.04] p-5" data-testid={`perk-${i}`}>
              <p.icon size={22} className="text-mint" />
              <h3 className="mt-4 font-sans text-base font-semibold">{p.t}</h3>
              <p className="mt-2 text-sm text-white/60">{p.d}</p>
              <span className="mt-4 inline-block rounded-full border border-mint/30 px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-widest text-mint">Coming 2027</span>
            </div>
          ))}
        </div>
        <div className="mt-6 flex items-start gap-3 rounded-2xl border border-white/10 p-5 text-sm text-white/70" data-testid="perk-us">
          <Package size={18} className="mt-0.5 shrink-0 text-mint" />
          <span><b className="text-white">U.S. stays (Texas):</b> one complimentary case of bottled water on arrival for qualifying future U.S. stays. Coming 2027.</span>
        </div>
      </div>
      <div className="text-navy">
        <Eyebrow><span className="text-mint">Join the 2027 waitlist</span></Eyebrow>
        <div className="mt-4">
          <InquiryForm kind="waitlist_2027" extras={["market", "nights", "month", "party"]} subjectTitle="2027 Stays Waitlist" cta="Join the 2027 waitlist" testid="waitlist-form" successTitle="You're on the 2027 waitlist" />
        </div>
        <p className="mt-3 pr-16 text-xs text-white/50">Joining the waitlist is not a booking or reservation and no payment is taken.</p>
      </div>
    </div>
  </section>
);
